import { useState } from 'react';

import Stack from '@mui/material/Stack';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { DocumentCallback } from 'react-pdf/dist/shared/types.js';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PdfViewerProps {
  fileUrl: string; // can be a URL or a File object
}

export function PdfViewer({ fileUrl }: PdfViewerProps) {
  const [pdfDoc, setPdfDoc] = useState<DocumentCallback | null>(null);

  return (
    <Stack gap={2}>
      <Document file={fileUrl} onLoadSuccess={(pdf) => setPdfDoc(pdf)} onLoadError={console.error}>
        {/* render all pages */}
        {pdfDoc &&
          Array.from({ length: pdfDoc.numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              renderForms
              scale={1.5}
              // width={containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth}
            />
          ))}
      </Document>
    </Stack>
  );
}

export default PdfViewer;
